"use client"

import { type ReactNode, useCallback } from "react"
import { useRouter } from "next/navigation"

type CheckoutBackButtonProps = {
  children: ReactNode
  className?: string
}

export default function CheckoutBackButton({
  children,
  className,
}: CheckoutBackButtonProps) {
  const router = useRouter()

  const handleBack = useCallback(() => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back()
      return
    }
    router.push("/cart")
  }, [router])

  return (
    <button
      type="button"
      onClick={handleBack}
      className={className}
      data-testid="back-to-cart-link"
    >
      {children}
    </button>
  )
}

